<template>
  
  <div id="app_content" class="admin">

    <h2 class="mt-0 uc">ciao <strong>{{ user.name }}</strong>, cosa devi fare oggi?</h2>

  </div>

</template>

<script>
// import { defineComponent } from '@vue/composition-api'

export default{

  data: function(){

    return {
      user: {},

    }

  },
  mounted(){
    this.$store.dispatch("getUserName");
    this.$store.watch(
      (state) => state.user.loaded,
      (value) => {
        if (value) {
          this.user = this.$store.state.user;
          //console.log(this.user);
        }
      }
    );
  },
}
</script>

<style scoped>

</style>